import React from "react";
import styled from "styled-components";
import SkillsItem from "./SkillsItem";
import Container from "../../Container";
import SkillsImage from "../../../img/skills-hearts.png";

const SkillsContainer = styled(Container)`
  max-width: 120rem;
`;

const PrimarySkillsItem = styled(SkillsItem)`
  padding-top: 2.8rem;
  margin-bottom: 7.2rem;
  @media only screen and (min-width: 500px) {
    max-width: 72rem;
    margin-left: auto;
    margin-right: auto;
    background: url("${SkillsImage}") 0px 0px no-repeat;
    background-position: 50% 1.2rem;
    background-size: 25.2rem;
  }
  @media only screen and (min-width: 768px) {
    background-size: 30rem;
    p {
      font-size: 1.8rem;
    }
  }
  @media only screen and (min-width: 850px) {
    background-size: 34rem;
  }
`;

const SkillsWrapper = styled.div`
  display: grid;
  grid-column-gap: 48px;
  grid-template-columns: repeat(1, 1fr);
  @media only screen and (min-width: 500px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media only screen and (min-width: 850px) {
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 60px;
  }
`;

const SkillsDivider = styled.div`
  width: 100%;
  margin-inline: auto;
  margin-block-end: 7.2rem;
  height: 0.1rem;
  background: linear-gradient(90deg, transparent 4%, rgba(0, 0, 0, 0.9), transparent 96%);

  &:after {
    content: "";
    width: "100%";
    height: 0.1rem;
    background: linear-gradient(90deg, transparent 4%, rgba(255, 255, 255, 0.3), transparent 96%);
    display: block;
    position: relative;
    top: -0.2rem;
  }

  @media only screen and (min-width: 768px) {
    background: linear-gradient(90deg, transparent 4%, rgba(0, 0, 0, 0.5), transparent 96%);

    &:after {
      background: linear-gradient(90deg, transparent 4%, rgba(255, 255, 255, 0.1.5), transparent 96%);
    }
  }
`;

const SkillsSpacer = styled.div`
  margin-block: 9.6rem;
`;

const Skills = () => {
  return (
    <React.Fragment>
      <SkillsContainer large center>
        <PrimarySkillsItem
          class="primarySkillsItem"
          title="SKILLS"
          icon="skillsIcon"
          description="Combining product design, design systems, prototyping, and technical fluency to solve customer and business problems."
        />

        <SkillsDivider />

        <SkillsWrapper>
          <SkillsItem
            title="PRODUCT DESIGN"
            icon="rgbaIcon"
            description="Use discovery, experimentation, and prototyping to validate ideas and guide product decisions."
          />

          <SkillsItem
            title="LEAN UX"
            icon="uxIcon"
            description="Facilitate discovery, testing, and validation to uncover opportunities, reduce risk, and guide product direction."
          />

          <SkillsItem
            title="DESIGN SYSTEMS"
            icon="designSystemIcon"
            description="Scale design through governance, reusable patterns, contribution models, and cross-functional enablement."
          />

          <SkillsItem
            title="AI PROTOTYPING"
            icon="aiIcon"
            description="Leverage LLMs and agent-based workflows to accelerate exploration, prototyping, delivery, and iteration."
          />

          <SkillsItem
            title="PRODUCT DELIVERY"
            icon="agileIcon"
            description="Collaborate across design, engineering, and product to deliver customer outcomes and measurable business value."
          />

          <SkillsItem
            title="SYSTEMS THINKING"
            icon="systemIcon"
            description="Create the governance, tooling, and contribution models that enable teams to scale consistently."
          />
        </SkillsWrapper>

        <SkillsSpacer />

        <PrimarySkillsItem
          class="primarySkillsItem"
          title="TECHNICAL CAPABILITY"
          icon="technicalIcon"
          description="Frontend technologies and platforms that support prototyping, experimentation, and delivery."
        />

        <SkillsDivider />

        <SkillsWrapper>
          <SkillsItem
            title="HTML"
            icon="htmlIcon"
            description="Build semantic, accessible interfaces that translate cleanly from design into production-ready experiences."
          />

          <SkillsItem
            title="CSS"
            icon="cssIcon"
            description="Create scalable layout systems, responsive patterns, and maintainable design foundations across products."
          />

          <SkillsItem
            title="REACT"
            icon="reactIcon"
            description="Comfortable working within React component architectures and modern frontend workflows."
          />

          <SkillsItem
            title="WEB COMPONENTS"
            icon="webComponentsIcon"
            description="Build accessible, framework-agnostic component systems using native browser technologies and standards."
          />

          <SkillsItem
            title="XCODE"
            icon="xcodeIcon"
            description="Prototype native iOS layouts in Xcode, leveraging AI-assisted coding to explore mobile UI patterns."
          />

          <SkillsItem
            title="BLENDER"
            icon="blenderIcon"
            description="Create 3D assets and concepts while applying systems thinking and reusable design principles."
          />
        </SkillsWrapper>
      </SkillsContainer>
    </React.Fragment>
  );
};
export default Skills;
